import apiClient from './api';
import type { ProductImage } from '../types/product';

export const productImageService = {
  getAll: async (productId: number): Promise<ProductImage[]> => {
    const response = await apiClient.get<ProductImage[]>(`/products/${productId}/images`);
    return response.data;
  },

  upload: async (productId: number, file: File): Promise<ProductImage> => {
    const formData = new FormData();
    formData.append('file', file);

    // Override the client's default JSON Content-Type so axios/browser sets multipart with boundary
    const response = await apiClient.post<ProductImage>(`/products/${productId}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  setMain: async (imageId: number): Promise<void> => {
    await apiClient.put(`/images/${imageId}/main`, {});
  },

  delete: async (imageId: number): Promise<void> => {
    await apiClient.delete(`/images/${imageId}`);
  },
};
